import * as types from "./actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "./eventTypes";
import { emptyObject } from "constants/emptyConst";

const propertiesReducer = (state = initialState.currentOffer.clientPropertiesData, action) => {
  switch (action.type) {
    case types.LOAD_PROPERTIES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false, saving: false };
      return result;
    }

    case types.LOAD_PROPERTIES_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true , saving: false};
      return result;
    }

    case types.LOAD_PROPERTIES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false , saving: false};
      return result;
    }

    case eventTypes.DOCUMENT_PARTNER_PROPERTIES_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: false, saving: false };
      return result;
    }

    case eventTypes.ALL_PROPERTIES_INVALIDATED:
      return emptyObject;

    case types.UPDATE_PROPERTIES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: true, saving: true };
      return result;
    }

    case types.UPDATE_PROPERTIES_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: true, saving: false };
      return result;
    }

    case types.UPDATE_PROPERTIES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: true, saving: false };
      return result;
    }

    default:
      return state;
  }
};

export default propertiesReducer;
